export const OnboardingGeneral = () => import('./OnboardingGeneral')
export const OnboardingLanguage = () => import('./OnboardingLanguage')
export const OnboardingStep = () => import('./OnboardingStep')
export const OnboardingInvest = () => import('./OnboardingInvest')
export const OnboardingAsset = () => import('./OnboardingAsset')
export const OnboardingTheme = () => import('./OnboardingTheme')